/**
 * @desc 通过退货单号获取退货单主数据
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asMaterialRejectBill.loadByMrbNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/loadByMrbNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
